import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { API_VERSION, BASE_URL } from '../../../environments/environment';
import { NotificationsService } from 'angular2-notifications';
import { AccountApi } from '../../shared/sdk/services/custom';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public forgotPasswordForm: FormGroup;
  public showErrorMessage: boolean = false;
  public mailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  constructor(public http: Http, public router: Router, public location: Location,
    private _NotificationService: NotificationsService, private _AccountApi: AccountApi) { }

  ngOnInit() {
    this.forgotPasswordForm = new FormGroup({
      'email': new FormControl(null, [Validators.required, Validators.pattern(this.mailPattern)])
    });
  }

  onSubmit() {
    if(!this.forgotPasswordForm.valid) {
      this.showErrorMessage = true;
    } else {
      this.showErrorMessage = false;
      this.http.post(BASE_URL + '/' + API_VERSION + '/forgotpassword', { email: this.forgotPasswordForm.value.email}).subscribe(data => {
        console.log('Password reset successs data', data);
        this._AccountApi.logout();
        this.router.navigate(['/login']);
        this._NotificationService.success('Message', 'Please check your mail to reset your password.');
      }, error => {
        console.log('Error while updating password', error);
        this._NotificationService.success('Message', 'Error, Please try again later.');
      });
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/app-modules/forgot-password/forgot-password.component.ts